enum ComponentType {
    Info = `info`,
    Image = `image`
}

export default ComponentType;